import { WarningBoxConfigBlockState } from './types';

const defaultState: WarningBoxConfigBlockState = {
    settings: {
        fontSize: 100,
        summariseWarnings: true,
        rowSize: 2,
        blockBackgroundColor: false,
        warnings: [],
        thresholds: [],
    },
    databilities: [],
};

export default defaultState;
